import type { StoreDirectLink, StoreServeLinks } from '@features/apps/types'

export const APPS_ROUTES = {
  landing: '/a/',
} as const

/** AppMetrica serve-ссылки (landing badges + mobile redirect) */
export const APPMETRICA_SERVE: StoreServeLinks = {
  apple: 'https://redirect.appmetrica.yandex.com/serve/818922990581394302',
  google: 'https://redirect.appmetrica.yandex.com/serve/170404690310291845',
  huawei: 'https://redirect.appmetrica.yandex.com/serve/821010311468352718',
} as const

/** Прямые ссылки на сторы (home DownloadApp). */
export const STORE_DIRECT_LINKS: {
  apple: StoreDirectLink
  google: StoreDirectLink
} = {
  apple: {
    href: 'https://apps.apple.com/ru/app/id1158898682?referrer=appmetrica_tracking_id%3D818922990581394302%26ym_tracking_id%3D12865574045399502275',
    title: 'Скачать приложение Farfor в AppStore',
    alt: 'AppStore',
    gtmEvent: 'appstore-click',
  },
  google: {
    href: 'https://play.google.com/store/apps/details?id=ru.farfor&referrer=appmetrica_tracking_id%3D170404690310291845%26ym_tracking_id%3D6050769962065580548',
    title: 'Скачать приложение Farfor в GooglePlay',
    alt: 'GooglePlay',
    gtmEvent: 'googleplay-click',
  },
}

export const DOWNLOAD_GTM_EVENTS = {
  storeApple: 'appstore-click',
  storeGoogle: 'googleplay-click',
  ctaMobile: 'appdown-mob',
} as const

export const APPS_LANDING_SEO = {
  title: 'Приложение для заказа вкусной еды от ресторана «Фарфор»',
  description:
    'Скачать приложение ресторана «Фарфор» для заказа вкусной еды с доставкой по России, Казахстану и Кыргызстану. Бесплатно для скачивания в AppStore, GooglePlay и AppGallery.',
} as const

export const APPS_SOCIAL_LINKS = [
  {
    key: 'vk',
    href: 'https://vk.com/farfordostavka',
  },
  {
    key: 'telegram',
    href: 'https://t.me/farfordostavkaTG',
  },
] as const
